import { render, staticRenderFns } from "./ProspectItem.vue?vue&type=template&id=0343ad32&scoped=true&"
import script from "./ProspectItem.vue?vue&type=script&lang=js&"
export * from "./ProspectItem.vue?vue&type=script&lang=js&"
import style0 from "./ProspectItem.vue?vue&type=style&index=0&id=0343ad32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0343ad32",
  null
  
)

export default component.exports